import { render, staticRenderFns } from "./YourProfileTab.vue?vue&type=template&id=3d66abd0&scoped=true"
import script from "./YourProfileTab.vue?vue&type=script&lang=js"
export * from "./YourProfileTab.vue?vue&type=script&lang=js"
import style0 from "./YourProfileTab.vue?vue&type=style&index=0&id=3d66abd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d66abd0",
  null
  
)

export default component.exports